module.exports = __webpack_public_path__ + "img/12.000c52c1.jpg";